import styled from "styled-components";
import { DefaultButton } from "./defaultButton";

export const ThirdaryButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.thirded};
	color: ${({ theme }) => theme.colors.white};
	svg {
		margin-right: 4px;
		path {
			fill: ${({ theme }) => theme.colors.thirded};
		}
	}

	transition: background-color 0.2s linear;
	&:hover  {
		background-color: ${({ theme }) => theme.colors.thirdedLightTouch};
	}
`;
